import axios from "axios";
import { API_URL } from "../constant";

const API_BASE_URL = API_URL || "https://staging.api.topcoinuk.com/api";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("auth_token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export const topCoinDistributionCardService = {
  getAllAssignments: async () => {
    const response = await api.get("/superadmin/topcoin-distribution-cards");
    return response.data;
  },

  generateCards: async (data) => {
    const response = await api.post("/superadmin/topcoin-distribution-cards/generate", data);
    return response.data;
  },

  getAvailablePrefixes: async () => {
    const response = await api.get("/superadmin/topcoin-distribution-cards/available-prefixes");
    return response.data;
  },

  getUnassignedCards: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.prefix) query.append("prefix", params.prefix);
    if (params.card_tier) query.append("card_tier", params.card_tier);
    if (params.top_coin_value) query.append("top_coin_value", params.top_coin_value);
    const queryString = query.toString();
    const url = queryString ? `/superadmin/topcoin-distribution-cards/unassigned?${queryString}` : `/superadmin/topcoin-distribution-cards/unassigned`;
    const response = await api.get(url);
    return response.data;
  },

  getCardsByBatch: async (batchTime = "") => {
    const url = batchTime
      ? `/superadmin/topcoin-distribution-cards/cards-by-batch?batch_time=${encodeURIComponent(batchTime)}`
      : `/superadmin/topcoin-distribution-cards/cards-by-batch`;
    const response = await api.get(url);
    return response.data;
  },

  getAvailableBundles: async () => {
    const response = await api.get("/superadmin/topcoin-distribution-cards/available-bundles");
    return response.data;
  },

  getBatchRecords: async (id) => {
    const response = await api.get(`/superadmin/topcoin-distribution-cards/${id}/records`);
    return response.data;
  },

  assignCards: async (data) => {
    const response = await api.post("/superadmin/topcoin-distribution-cards/assign", data);
    return response.data;
  },

  updateAssignment: async (id, data) => {
    const response = await api.put(`/superadmin/topcoin-distribution-cards/${id}`, data);
    return response.data;
  },

  deleteAssignment: async (id) => {
    const response = await api.delete(`/superadmin/topcoin-distribution-cards/${id}`);
    return response.data;
  },

  downloadAssignmentQrPdf: async (id, fileName = null) => {
    const response = await api.get(`/superadmin/topcoin-distribution-cards/${id}/qr-pdf`, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "application/pdf" });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileName || `TopCoin_QR_Cards_Assignment_${id}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  },

  downloadSingleCardQrPdf: async (cardId, cardNumber = null) => {
    const response = await api.get(`/superadmin/topcoin-distribution-cards/card/${cardId}/qr-pdf`, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "application/pdf" });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = cardNumber ? `TopCoin_QR_Card_${cardNumber}.pdf` : `TopCoin_QR_Card_${cardId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  },
};
